import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo variant="light" />
            <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
              Transparent 3PL fulfillment for growing Shopify and D2C brands. $2 per order. No minimums. No contracts.
            </p>
            <div className="mt-6 space-y-3 text-sm">
              <a href="mailto:info@shipmasterprep.com" className="flex items-center gap-3 hover:text-indigo-400 transition-colors">
                <Mail className="w-4 h-4" /> info@shipmasterprep.com
              </a>
              <a href="tel:+17863616017" className="flex items-center gap-3 hover:text-indigo-400 transition-colors">
                <Phone className="w-4 h-4" /> (786) 361-6017
              </a>
              <p className="flex items-center gap-3">
                <MapPin className="w-4 h-4" /> Weston, FL
              </p>
            </div>
          </div>

          <div>
            <p className="text-white font-bold mb-4">Company</p>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/#how-it-works" className="hover:text-indigo-400 transition-colors">How It Works</a></li>
              <li><a href="/#pricing" className="hover:text-indigo-400 transition-colors">Pricing</a></li>
              <li><a href="/#calculator" className="hover:text-indigo-400 transition-colors">Savings Calculator</a></li>
              <li><a href="/#comparison" className="hover:text-indigo-400 transition-colors">Comparison</a></li>
            </ul>
          </div>

          <div>
            <p className="text-white font-bold mb-4">Resources</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/zones" className="hover:text-indigo-400 transition-colors">Zone Map</Link></li>
              <li><Link to="/about" className="hover:text-indigo-400 transition-colors">About Us</Link></li>
              <li><Link to="/blog" className="hover:text-indigo-400 transition-colors">Blog</Link></li>
              <li><Link to="/integrations" className="hover:text-indigo-400 transition-colors">Integrations</Link></li>
              <li><Link to="/compare" className="hover:text-indigo-400 transition-colors">Compare 3PLs</Link></li>
              <li><Link to="/faq" className="hover:text-indigo-400 transition-colors">FAQ</Link></li>
              <li><a href="/#contact" className="hover:text-indigo-400 transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-7 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} Shipmaster Fulfillment LLC. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-indigo-400 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-indigo-400 transition-colors">Terms</Link>
            <button
              type="button"
              onClick={() => {
                // Reset and re-open the cookie banner.
                try { localStorage.removeItem('shipmaster_consent_v1'); } catch { /* ignore */ }
                window.dispatchEvent(new Event('shipmaster:open-cookie-banner'));
              }}
              data-testid="cookie-preferences-link"
              className="hover:text-indigo-400 transition-colors"
            >
              Cookie preferences
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
